import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireStaff = false, module = null }) {
  const { user, can } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div data-testid="auth-loading" className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const isStaff = user.role === "admin" || user.role === "returns_manager";
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (requireStaff && !isStaff) {
    return <Navigate to="/" replace />;
  }
  // Returns managers are restricted staff: keep them in the cockpit / ops console / receiving station.
  if (user.role === "returns_manager") {
    const allowed = ["/", "/admin", "/receiving", "/receiving-inventory", "/move-stock", "/training", "/support", "/settings"];
    if (!allowed.some((p) => location.pathname === p || (p !== "/" && location.pathname.startsWith(p + "/")))) {
      return <Navigate to="/" replace />;
    }
  }
  // Approval gate: non-admin users with a non-active status must see the pending page.
  if (!isStaff && user.status && user.status !== "active") {
    if (location.pathname !== "/pending") {
      return <Navigate to="/pending" replace />;
    }
  }
  // Per-module permission gate. Applies to brand users AND BoxHero employees
  // (a regular employee with billing.view=false is redirected away from /billing).
  // Returns managers are already path-restricted above.
  if (module && user.role !== "returns_manager" && !can(module, "view")) {
    return <Navigate to="/" replace />;
  }
  return children;
}
